import React from 'react';
import { StyleSheet, Text, View } from './base_components';

const styles = StyleSheet.create({
  titleActionLine: {
    minWidth: 0,
    alignSelf: 'stretch',
    marginTop: '2rem',
    marginLeft: '3rem',
    marginRight: '3rem',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  left: { maxWidth: '100%', flexDirection: 'row' },
  titleDetail: {
    flex: 1,
    minWidth: 0,
    marginRight: '1rem',
    flexDirection: 'row',
  },
  title: {
    maxWidth: '100%',
    color: '#555',
    fontSize: '3rem',
    lineHeight: '4.5rem',
    fontWeight: 'bold',
    wordBreak: 'normal',
    overflowWrap: 'anywhere',
  },
  detail: { marginLeft: '1rem', color: '#777', fontSize: '1.8rem' },
  buttons: {
    flexGrow: 1,
    flexShrink: 0,
    minHeight: '4rem',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
});

type Props = {
  style?: any;
  textStyle?: any;
  title?: string;
  detail?: string;
  children?: any;
};
export default function TitleActionLine(props: Props) {
  return (
    <View style={[styles.titleActionLine, props.style]}>
      <View style={styles.left}>
        <View style={styles.titleDetail}>
          <Text style={[styles.title, props.textStyle]}>{props.title}</Text>
          {props.detail ? (
            <Text style={[props.textStyle, styles.title, styles.detail]}>
              {props.detail}
            </Text>
          ) : null}
        </View>
      </View>
      <View style={styles.buttons}>{props.children}</View>
    </View>
  );
}
